import { makeVar, useReactiveVar } from '@apollo/client';

type WsClientData = {
  isConnectionActive: boolean;
  lastReconnectAttempt?: number;
  reconnectReason?:
    | 'visibility_change'
    | 'network_online'
    | 'ping_timeout'
    | 'error';
};

export const wsStatusVar = makeVar<WsClientData | undefined>(undefined);

export function setWsConnectionStatus(
  isActive: boolean,
  reconnectReason?: WsClientData['reconnectReason']
) {
  wsStatusVar({
    isConnectionActive: isActive,
    lastReconnectAttempt: isActive ? undefined : Date.now(),
    reconnectReason: isActive ? undefined : reconnectReason,
  });
}

export const useWsClientStatus = () => {
  const data = useReactiveVar(wsStatusVar);
  return {
    isConnectionActive: !!data?.isConnectionActive,
    lastReconnectAttempt: data?.lastReconnectAttempt,
    reconnectReason: data?.reconnectReason,
  };
};
